import styled from "styled-components"

import {IconTooltip, Overlay} from "@irati/ui/src/Tooltip"
import {minWidthMedia} from "@irati/ui/src/global/media"

export const StyledTooltip = styled(IconTooltip)`
  font-size: 14px;
  text-transform: lowercase;
`

export const StyledOverlay = styled(Overlay)`
  max-width: 260px;

  ${minWidthMedia.tablet`
    max-width: 300px;
  `}
`

export const StyledBr = styled.br`
  display: block;
  content: "";
  margin: 8px 0;
`
